var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductivityEqual(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 32C12.1111 32 11.6389 31.806 11.25 31.418C10.8611 31.03 10.6667 30.5589 10.6667 30.0045C10.6667 29.4503 10.8611 28.9776 11.25 28.5865C11.6389 28.1955 12.1111 28 12.6667 28H36.6667C37.2222 28 37.6945 28.194 38.0834 28.582C38.4722 28.97 38.6667 29.4412 38.6667 29.9955C38.6667 30.5498 38.4722 31.0225 38.0834 31.4135C37.6945 31.8045 37.2222 32 36.6667 32H12.6667ZM12.6667 20C12.1111 20 11.6389 19.806 11.25 19.418C10.8611 19.03 10.6667 18.5588 10.6667 18.0045C10.6667 17.4502 10.8611 16.9776 11.25 16.5866C11.6389 16.1955 12.1111 16 12.6667 16H36.6667C37.2222 16 37.6945 16.194 38.0834 16.582C38.4722 16.97 38.6667 17.4411 38.6667 17.9954C38.6667 18.5497 38.4722 19.0224 38.0834 19.4134C37.6945 19.8045 37.2222 20 36.6667 20H12.6667Z",
    fill: "#2196F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductivityEqual);
export default __webpack_public_path__ + "static/media/productivity-equal.afc08d39.svg";
export { ForwardRef as ReactComponent };